export const getHasJWT = (): boolean => !!localStorage.getItem("auth_token");
export const getJWT = (): string | null => localStorage.getItem("auth_token");
export const setJWT = (authToken: string): void =>
  localStorage.setItem("auth_token", authToken);

export const getHasRefreshToken = (): boolean =>
  !!localStorage.getItem("refresh_token");
export const getRefreshToken = (): string | null =>
  localStorage.getItem("refresh_token");
export const setRefreshToken = (refreshToken: string): void =>
  localStorage.setItem("refresh_token", refreshToken);

// Treat a token as expired slightly before it actually is, so a request that
// leaves here valid does not arrive expired after network latency.
const EXPIRY_SKEW_SECONDS = 30;

const decodeJWTPayload = (token: string): { exp?: number } | null => {
  const segments = token.split(".");
  if (segments.length !== 3) return null;

  try {
    const base64 = segments[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    return typeof payload === "object" && payload !== null ? payload : null;
  } catch {
    return null;
  }
};

/**
 * Whether the access token is past (or within EXPIRY_SKEW_SECONDS of) its exp.
 *
 * Reading `exp` client-side is only ever used to decide whether to refresh
 * early — the server remains the authority on whether a token is accepted, so
 * a token we cannot parse is reported as *not* expired and simply sent as-is.
 * A missing token, by contrast, is expired: there is nothing to send.
 */
export const isTokenExpired = (
  token: string | null,
  skewSeconds: number = EXPIRY_SKEW_SECONDS
): boolean => {
  if (!token) return true;

  const payload = decodeJWTPayload(token);
  if (typeof payload?.exp !== "number") return false;

  return payload.exp * 1000 <= Date.now() + skewSeconds * 1000;
};
